import {
  useEffect,
  useState,
  FC,
  useCallback,
} from 'react';
import { useSelector } from 'react-redux';
import dynamic from 'next/dynamic';

// import FooterComponent from 'components/Footer/Footer';
import { Store } from 'app-redux/types/storeTypes';
import { Footer } from 'src/__generated__/graphqlTypes';
import {
  BIO_SLUG,
  IS_CLIENT_SIDE,
  SCROLL_EVENT,
} from 'constants/constants';
import { CommonFooterInterface } from 'components/Footer/declarations';

const FooterComponent = dynamic(() => import('components/Footer/Footer'));

const FooterContainer: FC<CommonFooterInterface> = ({ footer }) => {
  const [isVisibleScrollTopButton, setScrollTopButtonVisibility] = useState<boolean>(false);
  const slug = useSelector((store: Store) => store.server.page.slug);
  const [shouldShowFooter, setShouldShowFooter] = useState<boolean>(true);
  const isMobile = useSelector((store: Store) => store.server.app.isMobileViewWidth);

  useEffect(() => {
    setShouldShowFooter(true);
  }, []);

  useEffect(() => {
    const handler = () => {
      const scrollTop = document.documentElement.scrollTop || document.body.scrollTop;
      const appearationLimit = window.innerHeight * 0.2;
      setScrollTopButtonVisibility(scrollTop > appearationLimit);
    };

    const isBioPage = slug === BIO_SLUG;

    if (!isBioPage) {
      window.addEventListener(SCROLL_EVENT, handler);
    }

    return () => window.removeEventListener(SCROLL_EVENT, handler);
  }, []);

  const scrollToTop = useCallback(() => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  }, []);

  if (IS_CLIENT_SIDE && isMobile && !shouldShowFooter) {
    return null;
  }

  return (
    <FooterComponent
      footer={footer as Footer}
      scrollToTop={scrollToTop}
      isVisibleScrollTopButton={isVisibleScrollTopButton}
    />
  );
};

export default FooterContainer;
